import {List} from 'immutable';
import {map} from 'rxjs/operators';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import Institution from './model';

export const fetchPincodes = () =>
    RESTClient.getAuthenticatedObservable('v2/logins/pincodes').pipe(
        map(response => {
            return List(response.map(institution => Institution.fromAPI(institution)));
        }),
    );
